export default __webpack_public_path__ + "static/media/handprint-28-29-page.6885496b.png";